import React, { useCallback, useState } from "react";
import "../style/drawer.scss";
import CveTable from "./CVETable";
import CveDrawer from "./CVEDrawer";
import BasicButtons from "./buttonChoice";

const CVEComponent = ({ filteredForTable, handleSiteButtonClick,handlePluginButtonClick,handleThemeButtonClick,handleCVEButtonClick,role }) => {

  // Le plugin lui-même, pas son rang : la liste est filtrée et triée, donc un index
  // désignait un autre plugin dès que le filtre changeait drawer ouvert.
  const [selectedPlugin, setSelectedPlugin] = useState(null);

  const handleRowClick = useCallback((plugin) => setSelectedPlugin(plugin), []);
  const handleCloseDrawer = useCallback(() => setSelectedPlugin(null), []);

  return (
    <>
      <BasicButtons
        place="cve"
        onSiteButtonClick={handleSiteButtonClick}
        onPluginButtonClick={handlePluginButtonClick}
        onThemeButtonClick={handleThemeButtonClick}
        onCVEButtonClick={handleCVEButtonClick}
        role={role}
      />
      <CveTable
        filteredPlugins={filteredForTable}
        handleRowClick={handleRowClick}
      />
      <CveDrawer
        selectedPlugin={selectedPlugin}
        handleCloseDrawer={handleCloseDrawer}
        role={role}
      />
    </>
  );
};

export default CVEComponent;
